import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import BackHeader from '../../components/BackHeader/BackHeader'
import { initialsFrom } from './logic'
import { useHold } from './store'
import Loading from '../../components/Loading/Loading'
import { HoldScreen } from './bits'

export default function MembersView() {
  const navigate = useNavigate()
  const { team, nameOf, loading } = useHold()
  const [query, setQuery] = useState('')
  if (loading && !team) return <HoldScreen><Loading fill /></HoldScreen>
  if (!team) return null

  const needle = query.trim().toLocaleLowerCase('da')
  const members = [...team.members]
    .filter((member) => nameOf(member.id).toLocaleLowerCase('da').includes(needle))
    .sort((a, b) => nameOf(a.id).localeCompare(nameOf(b.id), 'da'))

  return (
    <HoldScreen>
      <BackHeader
        eyebrow={team.name}
        title="Medlemmer"
        subtitle={`${team.members.length} på holdet`}
        onBack={() => navigate(`/hold/${team.id}`)}
      />
      <input
        className="hold-member-search"
        value={query}
        onChange={(event) => setQuery(event.target.value)}
        placeholder="Søg medlem"
        aria-label="Søg medlem"
      />
      {members.length === 0 ? <p className="hold-empty">Ingen medlemmer matcher.</p> : (
      <ul className="hold-member-sheet">
        {members.map((member) => {
          const name = nameOf(member.id)
          return (
            <li key={member.id} className="hold-member-card">
              <div className="hold-member-person">
                <span className="hold-fine-avatar" aria-hidden="true">{initialsFrom(name)}</span>
                <span className="hold-member-name">{name}</span>
              </div>
              <span className="hold-member-tags">
                {member.isAdmin ? <em>Admin</em> : null}
                {member.fineChair ? <em>Bøde-formand</em> : null}
              </span>
            </li>
          )
        })}
      </ul>
      )}
    </HoldScreen>
  )
}
